import { render, staticRenderFns } from "./BeltProducts.vue?vue&type=template&id=a9557866&scoped=true"
import script from "./BeltProducts.vue?vue&type=script&lang=js"
export * from "./BeltProducts.vue?vue&type=script&lang=js"
import style0 from "./BeltProducts.vue?vue&type=style&index=0&id=a9557866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9557866",
  null
  
)

export default component.exports